export const getP = (o, p) => p.split(".").reduce((a, k) => (a == null ? undefined : a[k]), o);

export const setP = (o, p, v) => {
  const c = structuredClone(o);
  const ks = p.split(".");
  let t = c;
  ks.slice(0, -1).forEach((k) => { t[k] = t[k] ?? {}; t = t[k]; });
  t[ks[ks.length - 1]] = v;
  return c;
};

export const RFC_RE = /^([A-ZÑ&]{3,4})(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([A-Z\d]{2}[A\d])$/;
export const validRfc = (r) => RFC_RE.test((r || "").trim().toUpperCase());

const nf = new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 });
export const money = (v) => (v === null || v === undefined || Number.isNaN(v) ? "n.d." : `$${nf.format(v)}`);
export const xx = (v) => (typeof v === "number" ? `${v.toFixed(2)}x` : "n.a.");
export const pc = (v, d = 1) => (typeof v === "number" ? `${(v * 100).toFixed(d)}%` : "n.a.");

export const GATE = {
  ok: ["Cumple", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  cond: ["Condición", "bg-amber-50 text-amber-700 border-amber-200"],
  exc: ["Excepción", "bg-violet-50 text-violet-700 border-violet-200"],
  fail: ["No cumple", "bg-rose-50 text-rose-700 border-rose-200"],
};
